import { handleCallback } from './handleCallback'
import { loadCreateUser, loadCreateUserNull } from './loadCreateUser'
import { login, logout } from './loginLogout'
import { loadSession } from './session'
import { getAccessToken } from './token'
import { Auth, AuthSettings } from './types'
import { storeUtmData } from './utmData'
import { recoverProviderSession } from './recoverProviderSession'

export const initAuth = async (authSettings: AuthSettings): Promise<Auth> => {
    storeUtmData()

    await handleCallback(authSettings)

    let session = authSettings.getSession ? await authSettings.getSession() : loadSession(authSettings)

    if (session && (await recoverProviderSession(authSettings, session))) {
        session = null
    }

    const result: Auth = {
        clientId: authSettings.clientId,
        userId: session ? session.userId : null,
        getAccessToken: session ? getAccessToken(authSettings) : () => Promise.resolve(null),
        login: session ? () => Promise.resolve() : login(authSettings),
        logout: session ? logout(authSettings, session) : () => Promise.resolve(),
        loadCreateUser: session ? loadCreateUser : loadCreateUserNull,
    }

    const { forceUser } = authSettings
    if (forceUser && result.login) {
        const currentUrl = new URL(window.location.href)
        const flow = currentUrl.searchParams.get('flow')?.toLowerCase() === 'signup' ? 'signup' : undefined
        await result.login({
            returnTo: window.location.href,
            flow,
            handoffTicket: currentUrl.searchParams.get('handoff_ticket') || undefined,
        })
    }

    return result
}
